
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';
// Components
import Question from '@/components/quiz/Question.vue';
// Types
import { Quiz as QuizType } from '@/types/quiz.d';

@Options({
  computed: {
    ...mapState(['currentQuiz', 'percentQuiz']),
  },
  components: {
    Question,
  },
})
export default class Quiz extends Vue {
  id = 1;

  currentQuiz!: QuizType;

  percentQuiz!: number;

  handleQuestion(value: string): void {
    if (this.id >= this.currentQuiz.questions.length) {
      this.$router.push({ name: 'Result' });
    } else {
      this.id = Number(value) + 1;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      document.getElementById('bar').style.width = `${this.percentQuiz}%`;
    }
  }
}
